var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"lock-file",attrs:{"src":require("mlearn/icons/document/lock-list.svg"),"alt":"lock"}})
}
var staticRenderFns = []

export { render, staticRenderFns }